import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL ?? 'http://localhost:3014';

export interface PlanStatus {
  plan: {
    _id: string;
    name: string;
    description?: string;
    maxAthletes: number;
    price: number;
    features?: Record<string, unknown>;
  };
  effectiveMaxAthletes: number;
  currentAthleteCount: number;
  remainingSlots: number;
  percentUsed: number;
  isOverLimit: boolean;
}

export function usePlanStatus() {
  return useQuery<PlanStatus>({
    queryKey: ['me-plan'],
    queryFn: () => axios.get<PlanStatus>(`${baseUrl}/me/plan`).then((r) => r.data),
    // staleTime 0: i dati sono considerati subito stale, così TanStack Query
    // ricarica automaticamente ad ogni mount/focus finestra dopo add/remove atleta.
    staleTime: 0,
  });
}
